// extracted by mini-css-extract-plugin
export default {"budgetFiltersContainer":"budgetFilters_budgetFiltersContainer__Zs1on","collapsableComponent":"budgetFilters_collapsableComponent__D5P9Q"};